import { useMemo } from 'react';

import { useGetTherapistsMatching } from '@helpful/network';
import { useContext } from 'use-context-selector';
import { useTranslation } from '@wearehelpful/ui-localization';

import { MatchingContext } from '../Matching.context';

import { AVATAR_SIZE } from './_partitions/TherapistCard';

export const useMatching = () => {
  const { t } = useTranslation();

  const {
    isLoading: isSurveyLoading,
    isSuccess: isSurveySuccess,
    survey,
  } = useContext(MatchingContext);

  const { data, isLoading: isMatchingLoading } = useGetTherapistsMatching(
    {
      acceptingNewPatients: true,
      state: survey?.response?.state,
      insurance: [survey?.response?.insuranceProvider],
      specialty: survey?.response?.supportType,
      picture: {
        width: AVATAR_SIZE * window.devicePixelRatio,
        height: AVATAR_SIZE * window.devicePixelRatio,
      },
    },
    {
      query: {
        enabled: isSurveySuccess,
      },
    }
  );

  const loading = isSurveyLoading || isMatchingLoading;

  const title = (() => {
    if (data?.best.length) return t('subheadings.therapistsMatching.title');
    return t('subheadings.therapistsMatchingConsult.title');
  })();

  const description = (() => {
    if (data?.best.length) return t('forms.therapistMatchingInformation');
    return t('forms.therapistMatchingConsultInformation');
  })();

  const bestMatch = useMemo(() => {
    if (data?.best.length) return data.best;
    return data?.default;
  }, [data]);

  return [{ bestMatch, other: data?.other, loading, title, description }];
};
